import styled from '@emotion/styled';
import Link from 'next/link';

import { transparentize } from '@/styles/utils';

export const PreviewBanner = () => (
  <PreviewBannerContainer>
    You are in preview mode,{' '}
    <Link href="/api/disable-draft" locale={false}>
      Exit preview mode
    </Link>
  </PreviewBannerContainer>
);

const PreviewBannerContainer = styled.div`
  background: ${transparentize('--decorative-eclipse', 90)};
  color: var(--text-strong);
  padding: var(--spacing-x-small) var(--spacing-x-small);
  box-shadow: var(--shadow-base);
  font-size: var(--font-size-x-small);

  z-index: 99;
  border-radius: var(--radius-s);

  position: fixed;
  bottom: var(--spacing-xx-small);
  left: var(--spacing-xx-small);
`;
